export const ADD_CHITTIE_PAYMENT_STARTED = 'ADD_CHITTIE_PAYMENT_STARTED';
export const ADD_CHITTIE_PAYMENT_COMPLETED = 'ADD_CHITTIE_PAYMENT_COMPLETED';
export const ADD_CHITTIE_PAYMENT_ERROR = 'ADD_CHITTIE_PAYMENT_ERROR';

export const FETCH_CHITTIE_PAYMENT_STARTED = 'FETCH_CHITTIE_PAYMENT_STARTED';
export const FETCH_CHITTIE_PAYMENT_COMPLETED =
  'FETCH_CHITTIE_PAYMENT_COMPLETED';
export const FETCH_CHITTIE_PAYMENT_ERROR = 'FETCH_CHITTIE_PAYMENT_ERROR';

export const UPDATE_CHITTIE_PAYMENT_STARTED = 'UPDATE_CHITTIE_PAYMENT_STARTED';
export const UPDATE_CHITTIE_PAYMENT_COMPLETED =
  'UPDATE_CHITTIE_PAYMENT_COMPLETED';
export const UPDATE_CHITTIE_PAYMENT_ERROR = 'UPDATE_CHITTIE_PAYMENT_ERROR';

export const CLEAR_PAYMENTS = 'CLEAR_PAYMENTS';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/chittiePaymentActionTypes.js